import {Component, OnInit, Input, Output, EventEmitter, OnDestroy, ViewChild} from '@angular/core';
import {Calendar} from "../../../entities/Calendar";
import {TaskPageModel, TaskTypes} from "../../../entities/PageModel";
import {Resource} from "../../../entities/Resource";
import {ResourceTaskTime} from "../../../entities/ResourceTaskTime";
import {Job} from "../../../entities/Job";
import {Task} from "../../../entities/Task";
import {EmployeeService} from "../../../services/employee.service";
import {TaskService} from "../../../services/task.service";
import {TimeplanService} from "../../../services/timeplan.service";
import {CalendarService} from "../../../services/calendar.service";
import {ConverterService} from "../../../services/converter.service";
import {JobService} from "../../../services/job.service";
import {ActivatedRoute, Router} from "@angular/router";
import {ConfigService} from "../../../services/config.service";
import * as moment from "moment";
import {environment} from "../../../../environments/environment";
import {JobCalendar} from "../../../entities/JobCalendar";
import {JobConverterService} from "../../../services/job-converter.service";
import {filter} from "@angular/cdk/rxjs";
import {Observable} from "rxjs";
import {LoginService} from "../../../services/login.service";
@Component({
  selector: 'app-responsible-calendar',
  templateUrl: './responsible-calendar.component.html',
  styleUrls: ['./responsible-calendar.component.css']

})
export class ResponsibleCalendarComponent implements OnInit, OnDestroy {

  calendar: JobCalendar = null;

  subscription;

  jobSubscription;

  firstRun: Boolean;

  calendarDate: string;

  calendarTask: Task = null;

  maxResourceNameLength: number = 1;

  responsibles: Resource[] = [];

  chosenResponsible: Resource;

  defaultAllResponsible : Resource = {No: 'Alle', title: 'Alle', Name: 'Alle'};


  @ViewChild('dumbComp') child;

  constructor(private employeeService: EmployeeService, private convertService: JobConverterService, private taskservice: TaskService,
              private timePlanService: TimeplanService, private calendarService: CalendarService,
              private ConvertService: ConverterService, private jobservice: JobService,
              private route: ActivatedRoute, private config: ConfigService,
              private router : Router, private loginService : LoginService) {
  }

  ngOnInit() {
    this.config.changeJobRelevance(false);
    this.firstRun = true;

    let sub = this.employeeService.getAllUsers().subscribe(responsibles => {
      this.responsibles.push(this.defaultAllResponsible);
      this.responsibles = this.responsibles.concat(responsibles);

      this.setChosenResponsible(this.loginService.getLoggedInUserID());
      sub.unsubscribe();

      this.refreshCalendar();
    });
  }

  setChosenResponsible(userNo : string)
  {
    this.chosenResponsible = this.responsibles.filter(x => x.No.toLowerCase().trim() == userNo.toLowerCase().trim())[0];
  }

  setResources(resources: Job[], groups : Resource[]) {
    this.maxResourceNameLength = 1;
    resources.forEach(x => {
      x.id = x.No;
      if (x.No.length > this.maxResourceNameLength) {
        this.maxResourceNameLength = x.No.length;
      }
    });

    groups.forEach(x => {
      if (x.Name.length > this.maxResourceNameLength) {
        this.maxResourceNameLength = x.Name.trim().length;
      }
    });
  }

  updateJob(job : Job)
  {
    this.jobservice.PutJob(this.ConvertService.ConvertFromSchedulerDate(job, true)).subscribe();
  }


  ngOnDestroy() {
    if(this.subscription != null) {
      this.subscription.unsubscribe();
    }
    if (this.jobSubscription != null)
      this.jobSubscription.unsubscribe();
    this.config.changeJobRelevance(true);
  }

  changeChosenResponsible(ref : string)
  {
    this.setChosenResponsible(ref);
    this.refreshCalendar();
  }

  changeGlobalJob(jobNo : string)
  {
    this.jobservice.GetJob(jobNo).subscribe(job => {this.config.changeJob(job);
      this.router.navigateByUrl('gantchart');});
    //let job = new Job();
    //job.No = jobNo;


  }



  // Call the servies to get fresh data to the calendar.
  refreshCalendar() {
    if(this.chosenResponsible == this.defaultAllResponsible) {
      let sub = this.jobservice.GetJobs().subscribe(jobs => {

        this.convertAndRerender(jobs.filter(x => this.responsibles.findIndex(y => y.No == x.SalesPersonRef) != -1), sub);
        }
      )
    }
    else{
      let sub = this.jobservice.GetJobsForResponsible(this.chosenResponsible.No).subscribe(jobs => {
       this.convertAndRerender(jobs, sub);
      })
    }
  };

  convertAndRerender(jobs: Job[], sub : any)
  {
    this.setResources(jobs, this.responsibles);
    this.calendar = this.convertService.convertFromResponsibleJobsToCalendar(
      jobs,
      this.chosenResponsible.Name == this.defaultAllResponsible.Name ? this.responsibles.slice(1, this.responsibles.length) : [this.chosenResponsible]);


    this.child.rerenderCalendar(this.calendar);

    sub.unsubscribe()
  }

}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/controllers/calendars/responsible-calendar/responsible-calendar.component.ts